module.exports = __webpack_public_path__ + "static/media/home-check-receipt.910aa71c.svg";